export type PluginSetupCopyState = 'idle' | 'copied' | 'error';

export const getPluginSetupHelperTranslationKey = (copyState: PluginSetupCopyState) => {
    if (copyState === 'error') {
        return 'website.pluginSetup.copyError';
    }

    return 'website.pluginSetup.helper';
};
